import './ProductFeature.css'

type ProductFeatureProps = {
  imageSrc: string
}

export default function ProductFeature({ imageSrc }: ProductFeatureProps) {
  return (
    <article className="product-feature overflow-hidden rounded-lg">
      <img src={imageSrc} alt="Tecma flat roof system" className="product-feature__image h-[138px] w-full object-cover min-[600px]:h-[170px] min-[900px]:h-[136px]" />
      <div className="flex flex-col gap-4 px-7 py-4 min-[600px]:flex-row min-[600px]:items-end min-[900px]:gap-6">
        <div className="flex-1">
          <h2 className="product-feature__title">Tecma Flat Roof System</h2>
          <p className="product-feature__description mt-3 max-w-[670px]">Complete flat roofing systems engineered for maximum protection, energy efficiency, and long-term performance.</p>
        </div>
        <a href="#products" className="product-feature__link shrink-0 text-sm font-extrabold">Learn More <span aria-hidden="true" className="ml-20 text-xl">›</span></a>
      </div>
    </article>
  )
}
